import React, { useEffect } from "react";

export default function useCrispChat(shop) {
  useEffect(() => {
    if (window.CRISP_TOKEN) {
      console.log(`CRISP TOKEN present, exiting`);
      return;
    }

    if (!shop) {
      return;
    }

    if (!["business", "enterprise"].includes(shop?.monthlyPlan)) {
      console.log(`Not a qualifying plan, exiting`);
      return;
    }

    window.$crisp = [];
    window.CRISP_WEBSITE_ID = "05c40527-6445-49bc-a850-150014b14daf";
    window.CRISP_TOKEN_ID = `${shop._id}${
      window?.realIdCurrentUser?.email
        ? `-${window?.realIdCurrentUser?.email}`
        : ""
    }`;
    $crisp.push([
      "set",
      "user:nickname",
      [
        `${
          Array.isArray(window?.realIdCurrentUser)
            ? window?.realIdCurrentUser?.first_name?.[0]
            : window?.realIdCurrentUser?.first_name
        } ${
          Array.isArray(window?.realIdCurrentUser)
            ? window?.realIdCurrentUser?.last_name?.[0]
            : window?.realIdCurrentUser?.last_name
        }` || shop.name,
      ],
    ]);
    $crisp.push([
      "set",
      "user:email",
      [window?.realIdCurrentUser?.email || shop.contactEmail],
    ]);
    $crisp.push(["set", "user:company", [shop.name]]);
    $crisp.push([
      "set",
      "session:data",
      [
        [
          ["platform", "wc"],
          ["shopName", shop.name],
        ],
      ],
    ]);

    (function () {
      var d = document;
      var s = d.createElement("script");

      s.src = "https://client.crisp.chat/l.js";
      s.async = 1;
      d.getElementsByTagName("head")[0].appendChild(s);
    })();
  }, [shop]);
}
